export const OrderConsts = {
    NUMBER_PATTERN: /^-?\d+$/,
    MYORDER_PAGE_TITLE: 'World of Sweets - My Orders',
    ORDER_DETAIL_PAGE_TITLE: 'World of Sweets - Order Detail',
    COPY_ORDER_PAGE_TITLE: 'World of Sweets - Copy Order Detail',
};